import {
  DateInput,
  FormItem,
  IFormItemProps,
  SelectInput,
  TextInput,
} from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { DesktopFilterPanel, RowElement } from '@framework/ui';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { CommunicationSearchableTypeSelectInput } from './CommunicationSearchableTypeSelectInput';

const CommunicationRowElement = styled(RowElement)`
  & + & {
    margin-top: 8px;
    ${down('sm')} {
      margin-top: 0;
      > .ant-col {
        padding-bottom: 8px;
      }
    }
  }
  & > .ant-col {
    ${down('sm')} {
      padding-bottom: 8px;
    }
  }
`;

const layout = {
  removeHelpMargin: true,
} satisfies IFormItemProps['layout'];

export interface ICommunicationExtendSearchFormProps {
  size?: SizeType;
  formItemLayout?: IFormItemProps['layout'];
}

/**
 * Form per la ricerca  FrontOffice.
 */
export function CommunicationExtendSearchForm(
  props: ICommunicationExtendSearchFormProps,
) {
  const { size = 'large', formItemLayout = layout } = props;
  const { t } = useTranslation();

  return (
    <DesktopFilterPanel>
      {/* Attenzione fare la versione per mobile */}

      {/* prima riga */}
      <CommunicationRowElement>
        <FormItem
          name="ordinamenti.0"
          label={t(
            'communication-extend-search-form.so',
            'Ordinamento',
          )}
          layout={layout}
        >
          <SelectInput
            size={size}
            style={{ minWidth: 200 }}
            name="ordinamenti.0"
            options={[
              {
                value: '-dataInvio',
                label: t(
                  'communication-extend-search-form.send-date',
                  'Data di Invio',
                ),
              },
              {
                value: 'oggetto',
                label: t(
                  'communication-extend-search-form.subject',
                  'Oggetto',
                ),
              },
              {
                value: 'idTipoComunicazione',
                label: t(
                  'communication-extend-search-form.communication-type',
                  'Tipo Comunicazione',
                ),
              },
            ]}
            placeholder={t(
              'communication-extend-search-form.sort-by',
              'Ordina per...',
            )}
          />
        </FormItem>
        <FormItem
          name="messaggio"
          label={t(
            'communication-extend-search-form.message',
            'Messaggio',
          )}
          layout={formItemLayout}
        >
          <TextInput
            size={size}
            allowClear
            name="messaggio"
            placeholder={t(
              'communication-extend-search-form.search-in-message',
              'Cerca nel messaggio...',
            )}
          />
        </FormItem>
      </CommunicationRowElement>

      {/* seconda riga */}
      <CommunicationRowElement>
        <FormItem
          name="dataInvioDal"
          label={t(
            'communication-extend-search-form.sent-after',
            'Inviata dopo il',
          )}
          layout={formItemLayout}
        >
          <DateInput
            size={size}
            name="dataInvioDal"
            allowClear
            aria-label="Inviata dopo il: Inserisci data nel formato Giorno / Mese / Anno"
            placeholder={t(
              'communication-extend-search-form.write-or-select-date',
              'Scrivi o seleziona la data...',
            )}
          />
        </FormItem>
        <FormItem
          name="dataInvioAl"
          layout={{ ...formItemLayout }}
          label={t(
            'communication-extend-search-form.sent-before',
            'Inviata prima del',
          )}
        >
          <DateInput
            size={size}
            name="dataInvioAl"
            allowClear
            aria-label="Inviata prima del: Inserisci data nel formato Giorno / Mese / Anno"
            placeholder={t(
              'communication-extend-search-form.write-or-select-date',
              'Scrivi o seleziona la data...',
            )}
          />
        </FormItem>
        <FormItem
          name="idTipoComunicazione"
          label={t(
            'communication-extend-search-form.communication-type',
            'Tipo Comunicazione',
          )}
          layout={formItemLayout}
        >
          <CommunicationSearchableTypeSelectInput
            size={size}
            name="idTipoComunicazione"
            allowClear
          />
        </FormItem>
      </CommunicationRowElement>
    </DesktopFilterPanel>
  );
}
